import { useEffect, useState } from 'react'
import { EXAMPLE_REQUESTS } from './data'
import { IFooter, useFooter } from './footer-context'
import { useFirstRun } from './store'

/** The placeholder cycles through examples so the box explains itself. */
export const useCyclingPlaceholder = (active: boolean) => {
   const [i, setI] = useState(0)
   useEffect(() => {
      if (!active) return
      const t = setInterval(() => setI((n) => (n + 1) % EXAMPLE_REQUESTS.length), 3200)
      return () => clearInterval(t)
   }, [active])
   return `Try: “${EXAMPLE_REQUESTS[i]}”`
}

/** A setup step's footer: Back is hidden on the first step. */
export const useStepFooter = (action: string, onAction: () => void, extra: Partial<IFooter> = {}) => {
   const { back, step, steps } = useFirstRun()
   const first = steps()[0] === step
   useFooter({ action, onAction, back: first ? null : back, ...extra })
}
